import type {
  ActionActionItemUnion,
  Click,
  ExternalNavigation,
  InternalNavigation,
} from "~/core";

export const isExternalLink = (
  action: ActionActionItemUnion | null | undefined,
): action is ExternalNavigation => {
  return "href" in (action ?? {});
};
export const isInternalLink = (
  action: ActionActionItemUnion | null | undefined,
): action is InternalNavigation => {
  return "page" in (action ?? {});
};
export const isClickAction = (
  action: ActionActionItemUnion | null | undefined,
): action is Click => {
  return "type" in (action ?? {});
};
